import React from "react";

export const Solar = [
  // <>
  //   <h4 className="slideTitle">Office Solutions</h4>
  //   <div className="slideContainer slide_solidColour">
  //     <img
  //       src="images/solar.jpg"
  //       width="900px"
  //       height="auto"
  //       className="mx-auto"
  //     />
  //   </div>
  // </>,
  <>
    <h4 className="slideTitle">
      On-site Energy Solutions & Benefits for Customers
    </h4>
    <div className="slideContainer slide_solidColour">
      <img
        src="images/batteryStorage-benefits.JPG"
        width="100%"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
  <div className="slideContainer slide_solidColour noGutters">
    <div className="colLeft col50 backgroundImage">
      <img src="images/batteryStorage-onsite.JPG" width="100%" height="auto" />
    </div>
    <div className="colRight col50 solidColourContainer">
      <h4 class="slideTitle">On-Site Generation and Storage</h4>
      <p>
        <strong>
          We supply integrated energy solutions to help our customers lower
          carbon footprint and have better control over their energy needs.
        </strong>
      </p>
      <p>Shell on-site turn-key solutions include:</p>
      <ul class="shell_bullets_list">
        <li>
          <strong>On-site generation assets</strong> and energy infrastructure
          to help protect business operations from external events and outages
        </li>
        <li>
          <strong>
            Energy infrastructure management & upgrades to reduce waste and
            emissions
          </strong>
        </li>
        <li>
          An affordable <strong>solutions platform</strong> designed to reduce
          total cost of energy and operations & maintenance.
        </li>
      </ul>
    </div>
  </div>,
  // <>
  //   <h4 className="slideTitle">Shell: A Global Leader in Natural Gas</h4>
  //   <div className="slideContainer slide_solidColour">
  //     <div className="colLeft col50 solidColourContainer grey stats">
  //       <div class="d-flex">
  //         <p className="figureContainer">
  //           <span className="figure">INVESTMENT</span>
  //           <br />
  //           Stakes in <strong>Cleantech Solar solutions</strong> and{" "}
  //           <strong>Silicon Ranch</strong> respectively serving customers across
  //           Asia and the US
  //         </p>
  //       </div>
  //     </div>
  //     <div className="colRight col50 solidColourContainer">
  //       <p>
  //         <strong>7.5 GWh a year</strong> Rooftop solar at Shell units in
  //         Europe, Asia for power generation
  //       </p>
  //       <p className="text-center">
  //         <img
  //           alt=""
  //           src="images/renewablePower-solar.png"
  //           width="auto"
  //           height="100px"
  //         />
  //       </p>
  //       <p>
  //         Shell PPA for electricity from{" "}
  //         <strong>100 MW Energy storage facility</strong> in the UK
  //       </p>
  //       <p className="text-center">
  //         <img alt="" src="images/battery-storage.svg" width="auto" height="50px" />
  //         <img alt="" src="images/battery-storage.svg" width="auto" height="50px" />
  //         <img alt="" src="images/battery-storage.svg" width="auto" height="50px" />
  //         <img alt="" src="images/battery-storage.svg" width="auto" height="50px" />
  //       </p>
  //     </div>
  //   </div>
  // </>,
  <>
    <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
    <h4 className="slideTitle">Battery to support EV fast charging</h4>
      <ul className="shell_bullets_list">
        <li>
          Enable EV fast charging by providing an alternative to a grid upgrade
        </li>
        <li>
          Possibility to further optimize energy costs, e.g. ancillary services
          imbalance and network charge avoidance
        </li>
        <li>Supporting site’s power system reliability</li>
        <li>Turnkey solution - construction, operations and maintenance</li>
        <li>Technical and commercial assurance according to Shell standards</li>
      </ul>
      <p>
        <strong>Recent deployment</strong>
      </p>
      <ul className="shell_bullets_list">
        <li>Retail site in NL - battery size: ~ 300kW / 360kWh</li>
      </ul>
      </div>
      <div class="colRight col50">
        <img src="images/batteryStorage-ev1.JPG" className="mb-2" width="100%" height="auto" alt="" />
        <img src="images/batteryStorage-ev2.jpg" width="100%" height="auto" alt="" />
      </div>
    </div>
  </>,
];
